import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=084460a0&scoped=true&"
import script from "./Resource.vue?vue&type=script&lang=ts&"
export * from "./Resource.vue?vue&type=script&lang=ts&"
import style0 from "./Resource.vue?vue&type=style&index=0&id=084460a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084460a0",
  null
  
)

export default component.exports